import { myAxios } from "./myAxios";
import qs from "qs";
import store, { clearPersistanceStorage, test12 } from "@/store";

export {
  login,
  login_by_token,
  logout,
  refreshUser,
  register,
  loginWithMconnect,
};

function login(username, password) {
  const params = {
    login: username,
    password: password,
  };

  return myAxios.post("api/v1/login/", params, {
    headers: {
      "content-type": "application/json",
    },
  });
}
function loginWithMconnect(mconnectToken) {
  let data = { token: mconnectToken };
  return myAxios.post("api/v1/token", mconnectToken);
}
function login_by_token(token) {
  return myAxios.get(
    "api/v1/login?token=" + token
    // {
    //     headers: {
    //         'content-type': 'application/json',
    //     }
    // }
  );
}

function register(email, password, userType, applicationTypeId) {
  const params = {
    email: email,
    userType: userType,
    password: password,
    applicationTypeId: 11, //applicationTypeId
  };

  return myAxios.post("api/v1/auth/register", params, {
    headers: {
      "content-type": "application/json",
    },
  });
}

function logout() {
  localStorage.removeItem("user"); //
  localStorage.removeItem("selected-device");
  // localStorage.removeItem("proto"); //
  localStorage.removeItem("route"); //
  localStorage.removeItem("cart"); //
  localStorage.removeItem("distributor"); //
  localStorage.removeItem("transactions"); //

  // store.commit("proto/clearProto");
  // store.commit("leaflet/resetStorage")
}

function refreshUser() {
  return myAxios.get("/api/v1/manage/test");
}
